<template>
  <!-- NOTIFICATIONS -->
  <div>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" >
    <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="notifCount"   />

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ notifCount }} New</h3>
        <p class="opacity-75">Notifications</p>
      </div>

      <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
        <ul  class="bordered-items" v-if="getNotifications">
          <li v-for="ntf in getNotifications" :key="ntf.index" @click="onNotifMarkAsViewed(ntf.id)" v-bind:class="ntf.isUnread ? 'flex justify-between px-4 py-4 notification cursor-pointer bg-indigo-100' : 'flex justify-between px-4 py-4 notification cursor-pointer'" >
            <div class="flex items-start" >
              <feather-icon :icon="labelIcon(ntf.title)" :svgClasses="[`text-${labelColor(ntf.title)}`, 'stroke-current mr-1 h-6 w-6']" ></feather-icon>
              <div class="mx-2" >
                <span class="font-medium block notification-title" :class="[`text-${labelColor(ntf.title)}`]">{{ ntf.title }}</span>
                <!-- <a :href="ntf.actionlink"> <small>{{ ntf.msg }}</small></a> -->
                <small>{{ ntf.details }}</small>
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap">{{ getElapsedTime(ntf.createdOn) }}</small>
          </li>
        </ul>
      </component>

      <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer">
        <span>View All Notifications</span>
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
  
  
  </div>
</template>

<script>
import VuePerfectScrollbar    from 'vue-perfect-scrollbar'
import * as signalR           from '@aspnet/signalr'
import moment                 from 'moment'

export default {
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      unreadNotifications: [],
      connection: null,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60,
      },
      interval:null,
      count: 0,
      ctr: 0
      
    }
  },
  created() {
    this.getNotifications = null
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.$http.defaults.baseURL}/notificationhub`, {
                accessTokenFactory: () => { return localStorage.getItem('accessToken') }})
      .configureLogging(signalR.LogLevel.None)
      .build();
    
    //  this.refreshNotif()
  },
  mounted() {
    if(this.$store.state.auth.isUserLoggedIn()){
        const start = async () => {
            try {
                await this.connection.start();
                // console.log('connected');
                this.connection.invoke("OnConnected")//.catch(err => console.log(err.message));
            } catch (err) {
                // console.log("NOT connected. " + err);
                setTimeout(() => start(), 5000);
            }
        }

        start()
        this.connection.on("Add", (value) => {
          // //console.log(value)
        this.getNotifications = value
          
          const data = JSON.parse(value)

          
          switch(data.notification.Type){
            case 2: //TimeSheet
              break;
            case 3: { //Leave
              const payload1 = {
                sortBy: 'FromDate',
                sortOrder: 'Desc',
                pageNumber: 1,
                pageSize: -1,
                isApprover: true
              }
                this.$store.dispatch('leavemanagement/getAllLeaves', payload1)
                    .then(() => {
                       this.$vs.notify({
                        title: data.notification.Title,
                        text: data.notification.Details,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: this.labelColor(data.notification.Title)                  
                      })
                    })
              const payload2 = {
                sortBy: 'FromDate',
                sortOrder: 'Desc',
                pageNumber: 1,
                pageSize: -1,
                isApprover: false
              }
                this.$store.dispatch('leavemanagement/getAllLeaves', payload2)
                  
              break;
            }
            case 4: //Loans
              break;
            case 5: { //Overtime
              const ot1 = {
                        sortBy: 'OTDate',
                        sortOrder: 'Desc',
                        pageNumber: 1,
                        pageSize: -1,
                        isApprover: true
                    }
                    this.$store.dispatch('overtime/getAllEmployeeOvertime', ot1)
              const ot2 = {
                        sortBy: 'OTDate',
                        sortOrder: 'Desc',
                        pageNumber: 1,
                        pageSize: -1,
                        isApprover: false
                    }
                    this.$store.dispatch('overtime/getAllEmployeeOvertime', ot2)
              break;
            }
            case 6://Claims
              break;
          }

        
          
          //console.log(this.getNotifications)
          this.notifCount
          let n = JSON.parse(value)
          //console.log(n.notification)
          //console.log(this.getNotifications)
          this.$store.commit('ADD_NOTIFICATION', n.notification)
          this.notifCount
          const payload1 = {
                sortBy: 'FromDate',
                sortOrder: 'Desc',
                pageNumber: 1,
                pageSize: 20,
                isApprover: true
              }
                this.$store.dispatch('leavemanagement/getAllLeaves', payload1)
          const payload2 = {
                sortBy: 'FromDate',
                sortOrder: 'Desc',
                pageNumber: 1,
                pageSize: 20,
                isApprover: false
              }
                this.$store.dispatch('leavemanagement/getAllLeaves', payload2)

          
    
        })
        this.connection.on("Delete", () => {})

        this.connection.onclose(() => start());

        
   
    }
    
  },
  destroyed() {
    clearInterval(this.interval);    
  },
  computed: {
    getNotifications: {
      get() { return this.$store.state.getNotifications } ,
      set(value) {
        void value
        this.$store.dispatch('getNotification').catch(() => {})
      }
    },
    scrollbarTag() { return this.$store.getters.scrollbarTag },
    notifCount() { return this.$store.getters.getNotificationsUnread },
    labelColor () {
      return (label) => {
        if      (label.includes("ALERT")) return 'danger'
        else if (label.includes("Submitted")) return 'success'
        else if (label.includes("Approved"))  return 'success'
        else if (label.includes("Retracked")) return 'dark'
        else if (label.includes("Cancelled")) return 'danger'
        else if (label.includes("Revision")) return 'warning'
        else if (label.includes("Denied")) return 'danger'
        else return 'primary'
      }
    },
    labelIcon () {
      return (Icon) => {
        if      (Icon.includes("ALERT"))  return 'AlertCircleIcon'
        else if (Icon.includes("Submitted") || Icon.includes("Update"))  return 'CalendarIcon'
        else if (Icon.includes("Approved"))  return 'CheckCircleIcon'
        else if (Icon.includes("Retracked")) return 'RotateCcwIcon'
        else if (Icon.includes("Cancelled")) return 'XIcon'
        else if (Icon.includes("For Revision")) return 'EditIcon'
        else if (Icon.includes("Denied")) return 'XCircleIcon'
        else return 'MessageSquareIcon'
      }
    },
    getElapsedTime() {
      return (t) =>  this.elapsedTime(moment.utc(t).local().format())
    }
    
  },
  methods: {
    elapsedTime(startTime) {
      let x        = new Date(startTime)
      let now      = new Date()
      var timeDiff = now - x
      timeDiff    /= 1000

      var seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      var minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      var hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      var days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      var years   = timeDiff

      if (years > 0) {
        return years + (years > 1 ? ' years ' : ' year ') + 'ago'
      } else if (days > 0) {
        return days + (days > 1 ? ' days ' : ' day ') + 'ago'
      } else if (hours > 0) {
        return hours + (hours > 1 ? ' hrs ' : ' hour ') + 'ago'
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? ' mins ' : ' min ') + 'ago'
      } else if (seconds > 0) {
        return seconds + (seconds > 0 ? ' sec ago' : 'just now')
      }

      return years
    },
    // Method for creating dummy notification time
    randomDate({ hr, min, sec }) {
      let date = new Date()

      if (hr) date.setHours(date.getHours() - hr)
      if (min) date.setMinutes(date.getMinutes() - min)
      if (sec) date.setSeconds(date.getSeconds() - sec)

      return date
    },
    
    onNotifMarkAsViewed(index) {
      //console.log(this.$store.state.getNotifications)
      this.$store.dispatch('markAsViewed', index)
        .then(() => {
          this.getNotifications = null
        })
    }
  
  },
}

</script>

